/**
 * Hidden SVG filter definitions referenced by src/tailwind.css
 * (html[data-cvd="..."] { filter: url(#cvd-...) }). Rendered once, globally.
 * Matrices are the standard, widely-used color-vision-deficiency transforms
 * (the same family used by browser DevTools' vision-deficiency emulation),
 * shifting the page's palette to preview how it reads for each condition.
 */
export default function CvdFilters() {
  return (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true" data-a11y-exclude>
      <defs>
        <filter id="cvd-protanopia">
          <feColorMatrix
            type="matrix"
            values="0.567 0.433 0     0 0
                    0.558 0.442 0     0 0
                    0     0.242 0.758 0 0
                    0     0     0     1 0"
          />
        </filter>
        <filter id="cvd-deuteranopia">
          <feColorMatrix
            type="matrix"
            values="0.625 0.375 0   0 0
                    0.7   0.3   0   0 0
                    0     0.3   0.7 0 0
                    0     0     0   1 0"
          />
        </filter>
        <filter id="cvd-tritanopia">
          <feColorMatrix
            type="matrix"
            values="0.95 0.05  0     0 0
                    0    0.433 0.567 0 0
                    0    0.475 0.525 0 0
                    0    0     0     1 0"
          />
        </filter>
      </defs>
    </svg>
  );
}
